import { usePDF } from '@react-pdf/renderer';
import React, { useEffect, useMemo } from 'react';
import { TemplateRenderer, useTemplateOrFallback } from 'PDF/TemplateEngine';

function Dowload({ data, config, fileName }) {
  const { template, loading } = useTemplateOrFallback('ranking_mensual');

  const document = useMemo(() => {
    if (!template) return null;
    return <TemplateRenderer template={template} data={data} config={config || {}} />;
  }, [template, data, config]);

  const [instance, updateInstance] = usePDF({ document });
  useEffect(() => {
    if (document) updateInstance(document);
  }, [document, updateInstance]);

  if (loading || instance.loading) return <div>Generando PDF...</div>;
  if (!template) return <div>No se pudo cargar la plantilla</div>;
  if (instance.error) return <div>Error al generar el PDF: {String(instance.error)}</div>;
  return (
    <a href={instance.url} download={fileName || 'ranking-mensual.pdf'}>
      Descargar PDF
    </a>
  );
}

export default Dowload;
